import type { RouteParamsRequest } from '@pba/react-utils';
import type { paths } from '@pba/types-openapi-node';
import { type ApiClientResponse, nodeApiClient, nodeApiRoutes } from 'common/services';

export type DeleteEventAttachmentRequestPathParams =
  paths['/events/{eventId}/attachments/{attachmentId}']['delete']['parameters']['path'];
type DeleteEventAttachmentResponseData =
  paths['/events/{eventId}/attachments/{attachmentId}']['delete']['responses']['200']['content']['application/json'];

export const deleteEventAttachment = async ({
  routeParams: { attachmentId, eventId },
}: RouteParamsRequest<DeleteEventAttachmentRequestPathParams>) =>
  nodeApiClient.delete<DeleteEventAttachmentResponseData, ApiClientResponse<DeleteEventAttachmentResponseData>>(
    nodeApiRoutes.events.attachments.delete(eventId, attachmentId),
  );
